import commonRoutes from './commonRoutes';
import crmRoutes from './crmRoutes';
import projectRoutes from './projectRoutes';
import inventoryRoutes from './inventoryRoutes';
import boardRoutes from './boardRoutes';
import settingsRoutes from './settingsRoutes';
import approvalRoutes from './approvalRoutes';
import resourceRoutes from './resourceRoutes';
import hrRoutes from './hrRoutes';
import scheduleRoutes from './scheduleRoutes';

/**
 * MainLayout 하위에 렌더링되는 전체 라우트.
 *
 * 모듈이 추가되면(전자결재 / 자원관리 / 인사관리) 이 파일에
 * `import approvalRoutes from './approvalRoutes'` 한 줄과 배열 항목만 추가하면 된다.
 * App.jsx 는 더 이상 수정할 필요가 없다.
 */
const appRoutes = [
  ...commonRoutes,
  ...crmRoutes,
  ...projectRoutes,
  ...inventoryRoutes,
  ...boardRoutes,
  ...settingsRoutes,
  ...approvalRoutes,
  ...resourceRoutes,
  ...hrRoutes,
  ...scheduleRoutes,
  // 인사관리의 사용자관리·조직관리는 기존 경로(settingsRoutes)를 그대로 쓰고
  // 메뉴 위치만 인사관리 하위로 옮겼다(경로 유지 → 기존 권한·즐겨찾기 보존).
];

export default appRoutes;
